import AdminCategoryList from './AdminCategoryList';
export default AdminCategoryList;
